import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  loader: {
    textAlign: "center",
  },
}));

export default function Loader(props) {
  const classes = useStyles();

  return (
    <div className={classes.root} {...props}>
      <CircularProgress />
    </div>
  );
}
